import { BrowserModule } from '@angular/platform-browser';
import { Component,NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { HttpClientModule } from '@angular/common/http';

import { Globals } from './globals';
import { FeedbackService } from './services/feedback.service';
import { AppComponent } from './app.component';
import { WelcomeComponent } from './welcome/welcome.component';
import { RegistrationComponent } from './registration/registration.component';
import { FeedbackComponent } from './feedback/feedback.component';
import { FeedbackScoreComponent } from './feedback-score/feedback-score.component';
import { PagenotfoundComponent } from './pagenotfound/pagenotfound.component';
import { ScoreReportComponent } from './score-report/score-report.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { UserListComponent } from './user-list/user-list.component';


@NgModule({
  declarations: [
    AppComponent,
    WelcomeComponent,
    RegistrationComponent,
    FeedbackComponent,
    FeedbackScoreComponent,
    PagenotfoundComponent,
    ScoreReportComponent,
    PrivacyPolicyComponent,
    UserListComponent
  ],
  imports: [
    BrowserModule,
    HttpModule,
    FormsModule,
    HttpClientModule,
    RouterModule.forRoot([        
        { path: 'welcome', component: WelcomeComponent },  
        { path: 'registration', component: RegistrationComponent },  
        { path: 'feedback', component: FeedbackComponent },  
        { path: 'feedback-score', component: FeedbackScoreComponent },
        { path: 'score-report', component: ScoreReportComponent },
        { path: 'pagenotfound', component : PagenotfoundComponent },
        { path: 'privacy-policy', component : PrivacyPolicyComponent },
        { path: 'admin/user-list', component : UserListComponent },
        { path: '**', redirectTo : 'welcome' }
      ])
  ],
  providers: [Globals,FeedbackService],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// D:/xampp/htdocs/OESS_LFB_V2demo/src/app/app.module.ts